module.exports = __webpack_public_path__ + "img/yapital-alternative.dfa2d544.png";